import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-visualizza-copiaper-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-dialog #dialogcopie header="Copie di lavoro" [(visible)]="visible" [modal]="true" (onHide)="hide.emit($event)" [style]="{'width':'60%'}">
      <p class="py-3">Elenco delle posizioni delle copie per il documento con protocollo <strong>{{protocollo()??''}}</strong></p>
      <app-tabella-copiaper [copie]="copie()??[]" [canModified]="false" />
    </p-dialog>
  `
})
export class VisualizzaCopiaperDialogComponent {

  protocollo = input<string | undefined>("");
  copie = input<string[] | undefined | null>();
  visible = model.required<boolean>();
  hide = output();
}
